export const PLAY_AUDIO = "PLAY_AUDIO";
export const PAUSE_AUDIO = "PAUSE_AUDIO";
export const SET_AUDIO = "SET_AUDIO";
export const RESET_AUDIO = "RESET_AUDIO";
export const SET_PROGRESS = "SET_PROGRESS";

interface ActionTypes {
  PLAY_AUDIO: any;
  PAUSE_AUDIO: any;
  SET_AUDIO: any;
  RESET_AUDIO: any;
  SET_PROGRESS: any;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export function playAudio(): AudioPlayerActionsTypes {
  return {
    type: PLAY_AUDIO,
    payload: "",
  };
}

export function pauseAudio(): AudioPlayerActionsTypes {
  return {
    type: PAUSE_AUDIO,
    payload: "",
  };
}

export function setAudio(audio: object): AudioPlayerActionsTypes {
  return {
    type: SET_AUDIO,
    payload: audio,
  };
}
export function resetAudio(): AudioPlayerActionsTypes {
  return {
    type: RESET_AUDIO,
    payload: "",
  };
}

export function setProgress(progress: number): AudioPlayerActionsTypes {
  return {
    type: SET_PROGRESS,
    payload: progress,
  };
}

export type AudioPlayerActionsTypes = MessageAction;
try {
    // @ts-ignore
    setAudio.displayName = "setAudio";
    // @ts-ignore
    setAudio.__docgenInfo = { "description": "", "displayName": "setAudio", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/AudioPlayer/AudioPlayerActions.ts#setAudio"] = { docgenInfo: setAudio.__docgenInfo, name: "setAudio", path: "src/shared/containers/AudioPlayer/AudioPlayerActions.ts#setAudio" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setProgress.displayName = "setProgress";
    // @ts-ignore
    setProgress.__docgenInfo = { "description": "", "displayName": "setProgress", "props": { "toString": { "defaultValue": null, "description": "Returns a string representation of an object.\n@param radix Specifies a radix for converting numeric values to strings. This value is only used for numbers.", "name": "toString", "required": false, "type": { "name": "(radix?: number) => string" } }, "toFixed": { "defaultValue": null, "description": "Returns a string representing a number in fixed-point notation.\n@param fractionDigits Number of digits after the decimal point. Must be in the range 0 - 20, inclusive.", "name": "toFixed", "required": true, "type": { "name": "(fractionDigits?: number) => string" } }, "toExponential": { "defaultValue": null, "description": "Returns a string containing a number represented in exponential notation.\n@param fractionDigits Number of digits after the decimal point. Must be in the range 0 - 20, inclusive.", "name": "toExponential", "required": true, "type": { "name": "(fractionDigits?: number) => string" } }, "toPrecision": { "defaultValue": null, "description": "Returns a string containing a number represented either in exponential or fixed-point notation with a specified number of digits.\n@param precision Number of significant digits. Must be in the range 1 - 21, inclusive.", "name": "toPrecision", "required": true, "type": { "name": "(precision?: number) => string" } }, "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => number" } }, "toLocaleString": { "defaultValue": null, "description": "Converts a number to a string by using the current or specified locale.\n@param locales A locale string or array of locale strings that contain one or more language or locale tags. If you include more than one locale string, list them in descending order of priority so that the first entry is the preferred locale. If you omit this parameter, the default locale of the JavaScript runtime is used.\n@param options An object that contains one or more properties that specify comparison options.", "name": "toLocaleString", "required": false, "type": { "name": "(locales?: string | string[], options?: NumberFormatOptions) => string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/AudioPlayer/AudioPlayerActions.ts#setProgress"] = { docgenInfo: setProgress.__docgenInfo, name: "setProgress", path: "src/shared/containers/AudioPlayer/AudioPlayerActions.ts#setProgress" };
}
catch (__react_docgen_typescript_loader_error) { }